import Typography from "@mui/material/Typography";
import { ButtonProps } from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useCallback, useEffect, useMemo } from "react";
import { Dialog } from "../../../components/Dialog";
import { WhatsAppInstance } from "../../../types/whatsApp";
import { useStyles } from "../styles";
import { useMutation, useQuery } from "react-query";
import { findQrCode, reserveInstance } from "../../../services/whatsApp";
import Skeleton from "@mui/material/Skeleton";

type QrCodeWhatsAppProps = {
  data: WhatsAppInstance | null;
  open: boolean;
  onClose: () => void;
};

export function QrCodeWhatsApp({ data, open, onClose }: QrCodeWhatsAppProps) {
  const styles = useStyles();
  const actions: ButtonProps[] = useMemo(() => {
    return [
      {
        children: "Fechar",
        onClick: onClose,
      },
    ];
  }, [onClose]);

  const reserve = useMutation("reserve", async () => {
    const response = await reserveInstance(data?.id, data?.tipo_instancia);
    return response;
  });

  const qrCode = useQuery(["qrCode", data?.id], () => findQrCode(data?.id), {
    enabled:
      open && Boolean(data?.id) && (reserve.isSuccess || reserve.isError),
    refetchInterval: 20000,
  });

  const loadConfigs = useCallback(async () => {
    await reserve.mutateAsync();
  }, [reserve]);

  useEffect(() => {
    if (data?.id && open) {
      loadConfigs();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, open]);

  return (
    <Dialog
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      title={data?.name}
      open={open}
      actions={actions}
    >
      <Stack spacing={4} className={styles.rootContent}>
        <Typography>
          Nós usamos os seus contatos do WhatsApp para enviar mensagens.
        </Typography>
        <Typography variant="subtitle2">
          1 - Abra o WhatsApp em seu celular
        </Typography>
        <Typography variant="subtitle2">
          2 - Toque em Menu ou Configurações e selecione WhatsApp Web
        </Typography>
        <Typography variant="subtitle2">
          3 - Aponte a câmera de seu celular para o código abaixo
        </Typography>

        <Stack alignItems="center">
          {qrCode.isLoading || reserve.isLoading ? (
            <Skeleton variant="rectangular" width={200} height={200} />
          ) : qrCode.data?.qr ? (
            <img
              width={200}
              height={200}
              alt="alt-qr-code"
              src={qrCode.data?.qr}
            />
          ) : (
            <Typography>Instância conectada.</Typography>
          )}
        </Stack>
      </Stack>
    </Dialog>
  );
}
